import { Component, effect, HostListener, input, InputSignal, model, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipDirective, TooltipPosition } from '@vydaps/gui-commons';

@Component({
  selector: 'shared-core-dialog',
  standalone: true,
  imports: [TooltipDirective, NgClass],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  readonly isConfirmDisabled = input(false);
  readonly isCancelOnOutsideClickEnabled = input(false);
  readonly hasSecondaryCta = input(false);
  readonly confirmDisabledTooltip = input('');
  readonly confirmDisabledTooltipPosition: InputSignal<TooltipPosition> = input(
    'top' as TooltipPosition,
  );
  readonly title = input.required<string>();
  readonly cancelButtonText = input('Abbrechen');
  readonly confirmButtonText = input('Bestätigen');
  readonly width = input(510);

  readonly dialogOpened = model.required<boolean>();
  readonly blurBackground = input(false);

  readonly acknowledgeOnly = input(false);
  readonly withButtonBar = input(true);

  readonly confirmed = output();
  readonly canceled = output();
  readonly confirmedOnSecondaryCta = output();

  constructor() {
    effect(() => {
      if (!this.dialogOpened()) {
        document.querySelector('body')?.classList.remove('overflow-hidden');

        return;
      }

      document.querySelector('body')?.classList.add('overflow-hidden');
    });
  }

  @HostListener('window:keydown.escape')
  cancelOnEscape(): void {
    if (this.acknowledgeOnly()) return;

    this.cancel();
  }

  @HostListener('window:keydown.enter')
  confirmOnEnter(): void {
    this.confirm();
  }

  cancelOnOutsideClick(event: MouseEvent): void {
    if (this.acknowledgeOnly()) return;
    if (!this.isCancelOnOutsideClickEnabled() || event.target !== event.currentTarget) return;

    this.cancel();
  }

  cancel(): void {
    this.dialogOpened.set(false);
    this.canceled.emit();
  }

  confirm(): void {
    this.dialogOpened.set(false);
    this.confirmed.emit();
  }

  confirmOnSecondaryCta(): void {
    this.dialogOpened.set(false);
    this.confirmedOnSecondaryCta.emit();
  }
}
